import React, { useState } from 'react';

/* ============================================================
   SON Design System — Showcase (página única em React)
   Cole este arquivo como src/pages/ShowcaseApp.jsx (ou onde preferir)
   e use na sua rota:

     import ShowcaseApp from './pages/ShowcaseApp';
     <Route path="/showcase.html" element={<ShowcaseApp />} />

   Requer:
   - Tailwind configurado com os tokens do SON (tailwind.config.js)
   - Fontes Playfair Display + Inter carregadas globalmente
   ============================================================ */

/* ----------------------------- SVGIcon ----------------------------- */
const ICON_PATHS = {
  dashboard: (
    <>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </>
  ),
  universidade: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
    </>
  ),
  projetos: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
  ),
  crm: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  ),
  financeiro: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  ),
  marketing: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
  ),
  documentos: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
  ),
  agenda: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </>
  ),
  ia: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  ),
  comunidade: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
  ),
  configuracoes: (
    <>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </>
  ),
  perfil: (
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  ),
};

function SVGIcon({ name, className = 'w-5 h-5' }) {
  const path = ICON_PATHS[name];
  if (!path) return null;
  return (
    <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      {path}
    </svg>
  );
}

/* ----------------------------- Button ----------------------------- */
const BTN_BASE =
  'inline-flex items-center justify-center gap-2 font-body font-medium rounded-button transition-custom focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none select-none';
const BTN_VARIANTS = {
  primary: 'bg-primary text-white hover:opacity-90 active:scale-[0.98] shadow-sm',
  secondary: 'border border-primary text-primary bg-white hover:bg-background active:scale-[0.98]',
  tertiary: 'text-secondary hover:text-primary hover:bg-background/80',
  danger: 'bg-danger text-white hover:opacity-90 active:scale-[0.98]',
  success: 'bg-success text-white hover:opacity-90 active:scale-[0.98]',
};
const BTN_SIZES = {
  sm: 'h-9 px-3.5 text-small gap-1.5',
  md: 'h-11 px-5 text-body gap-2',
  lg: 'h-12 px-6 text-body font-semibold gap-2.5',
};

function Button({ variant = 'primary', size = 'md', loading = false, disabled = false, className = '', children, ...props }) {
  return (
    <button
      disabled={disabled || loading}
      className={`${BTN_BASE} ${BTN_VARIANTS[variant]} ${BTN_SIZES[size]} ${className}`}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-1 h-4 w-4 text-current" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {children}
    </button>
  );
}

/* ------------------------- Form Field controls ------------------------- */
function Label({ children, htmlFor, required }) {
  return (
    <label htmlFor={htmlFor} className="mb-1.5 block text-small font-medium text-text-primary font-body">
      {children}
      {required && <span className="text-danger ml-1">*</span>}
    </label>
  );
}

function Input({ error, success, className = '', ...props }) {
  const base =
    'w-full rounded-input border bg-white px-3.5 py-2.5 text-body font-body text-text-primary placeholder:text-text-secondary/50 transition-custom focus:outline-none focus:ring-2 disabled:bg-background disabled:text-text-secondary/50 disabled:cursor-not-allowed';
  const states = error
    ? 'border-danger focus:ring-danger/20 focus:border-danger'
    : success
    ? 'border-success focus:ring-success/20 focus:border-success'
    : 'border-border focus:ring-primary/20 focus:border-primary';
  return <input className={`${base} ${states} ${className}`} {...props} />;
}

function Checkbox({ label, checked, onChange, id, className = '' }) {
  return (
    <label htmlFor={id} className="flex items-center gap-2.5 cursor-pointer select-none font-body">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={`h-4.5 w-4.5 rounded-sm border-border text-primary focus:ring-primary/20 cursor-pointer ${className}`}
      />
      {label && <span className="text-small text-text-primary font-medium">{label}</span>}
    </label>
  );
}

function Switch({ checked, onChange, label, id }) {
  return (
    <label htmlFor={id} className="flex items-center gap-3 cursor-pointer select-none font-body">
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange?.(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:ring-offset-2 ${
          checked ? 'bg-primary' : 'bg-border'
        }`}
      >
        <span
          className={`inline-block h-4.5 w-4.5 transform rounded-full bg-white transition-transform duration-150 ${
            checked ? 'translate-x-5.5' : 'translate-x-1'
          }`}
        />
      </button>
      {label && <span className="text-small text-text-primary font-medium">{label}</span>}
    </label>
  );
}

/* ----------------------------- Modal ----------------------------- */
function Modal({ open, onClose, title, description, children, onConfirm, confirmText = 'Confirmar', cancelText = 'Cancelar', confirmVariant = 'primary' }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-primary/25 backdrop-blur-xs transition-opacity duration-200" onClick={onClose} />
      <div className="relative w-full max-w-[640px] rounded-modal bg-white shadow-lg border border-border p-8 font-body animate-in fade-in zoom-in-95 duration-200 z-10">
        <div className="flex items-start justify-between mb-3">
          <h2 className="font-display text-h3 font-semibold text-text-primary leading-tight">{title}</h2>
          <button
            onClick={onClose}
            aria-label="Fechar"
            className="text-text-secondary hover:text-text-primary transition-colors text-2xl leading-none -mt-1 p-1 hover:bg-background rounded-full w-8 h-8 flex items-center justify-center"
          >
            ×
          </button>
        </div>
        {description && <p className="text-text-secondary text-small mb-6 leading-relaxed">{description}</p>}
        <div className="text-text-primary text-body leading-relaxed mb-8">{children}</div>
        <div className="flex justify-end gap-3">
          <Button variant="tertiary" onClick={onClose}>
            {cancelText}
          </Button>
          {onConfirm && (
            <Button variant={confirmVariant} onClick={onConfirm}>
              {confirmText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

/* ------------------------- Alert / Toast ------------------------- */
const ALERT_VARIANTS = {
  success: { wrap: 'bg-success/10 border-success', iconColor: 'bg-success/20 text-success', icon: '✔' },
  warning: { wrap: 'bg-warning/10 border-warning', iconColor: 'bg-warning/20 text-warning', icon: '⚠' },
  error: { wrap: 'bg-danger/10 border-danger', iconColor: 'bg-danger/20 text-danger', icon: '❌' },
  info: { wrap: 'bg-info/10 border-info', iconColor: 'bg-info/20 text-info', icon: 'ℹ' },
};

function Alert({ variant = 'info', title, children }) {
  const v = ALERT_VARIANTS[variant];
  return (
    <div className={`flex gap-4 rounded-card border p-4.5 font-body shadow-sm ${v.wrap}`}>
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-caption font-bold ${v.iconColor}`}>
        {v.icon}
      </span>
      <div className="flex-1">
        {title && <h5 className="font-semibold text-small mb-1 leading-tight">{title}</h5>}
        <div className="text-small text-text-secondary leading-normal">{children}</div>
      </div>
    </div>
  );
}

const TOAST_BORDER = {
  success: 'border-success bg-white',
  warning: 'border-warning bg-white',
  error: 'border-danger bg-white',
  info: 'border-info bg-white',
};
const TOAST_ICON = {
  success: <span className="text-success text-body font-bold">✔</span>,
  warning: <span className="text-warning text-body font-bold">⚠</span>,
  error: <span className="text-danger text-body font-bold">❌</span>,
  info: <span className="text-info text-body font-bold">ℹ</span>,
};

function Toast({ open, onClose, message, type = 'success' }) {
  if (!open) return null;
  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-5 duration-200">
      <div className={`flex items-center gap-3.5 border-l-4 p-4.5 rounded-r-button shadow-md bg-white border-y border-r border-border font-body max-w-sm ${TOAST_BORDER[type]}`}>
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-background shrink-0">{TOAST_ICON[type]}</div>
        <p className="text-small font-medium text-text-primary mr-4">{message}</p>
        <button onClick={onClose} className="text-text-secondary hover:text-text-primary text-small transition-colors leading-none font-bold">
          ×
        </button>
      </div>
    </div>
  );
}

/* ----------------------------- Chart ----------------------------- */
function Chart({ title, type = 'line', data = [] }) {
  const points = data.length > 0 ? data : [30, 45, 35, 60, 40, 70, 65];
  const maxVal = Math.max(...points, 100);

  return (
    <div className="rounded-card border border-border bg-white p-6 font-body shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h4 className="text-small font-bold text-text-primary uppercase tracking-wider">{title || 'Performance'}</h4>
        <span className="text-caption text-text-secondary">Últimos 7 dias</span>
      </div>

      <div className="h-48 w-full flex items-end justify-between relative pt-4">
        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-40">
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
        </div>

        {type === 'bar' ? (
          <div className="w-full h-full flex items-end justify-around gap-2 z-10">
            {points.map((val, idx) => {
              const pct = (val / maxVal) * 100;
              return (
                <div key={idx} className="flex flex-col items-center flex-1 group">
                  <div style={{ height: `${pct}%` }} className="w-full max-w-[24px] bg-primary rounded-t-sm transition-all duration-300 group-hover:bg-secondary" />
                  <span className="text-caption text-text-secondary mt-2">{['S', 'T', 'Q', 'Q', 'S', 'S', 'D'][idx]}</span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="w-full h-full relative z-10">
            <svg viewBox="0 0 300 120" className="w-full h-full overflow-visible">
              <defs>
                <linearGradient id="chartGradShowcase" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#F2DB94" stopOpacity="0.4" />
                  <stop offset="100%" stopColor="#F2DB94" stopOpacity="0" />
                </linearGradient>
              </defs>
              {(() => {
                const step = 300 / (points.length - 1);
                const coords = points.map((p, i) => ({ x: i * step, y: 100 - (p / maxVal) * 80 }));
                const d = coords.map((c, i) => `${i === 0 ? 'M' : 'L'} ${c.x} ${c.y}`).join(' ');
                const areaD = `${d} L ${coords[coords.length - 1].x} 120 L 0 120 Z`;
                return (
                  <React.Fragment>
                    <path d={areaD} fill="url(#chartGradShowcase)" />
                    <path d={d} fill="none" stroke="#351514" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    {coords.map((c, i) => (
                      <circle key={i} cx={c.x} cy={c.y} r="3.5" className="fill-white stroke-primary stroke-2 hover:r-5 transition-all cursor-pointer" />
                    ))}
                  </React.Fragment>
                );
              })()}
            </svg>
            <div className="flex justify-between text-caption text-text-secondary mt-2 px-1">
              <span>Seg</span><span>Ter</span><span>Qua</span><span>Qui</span><span>Sex</span><span>Sáb</span><span>Dom</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ------------------------- WebWorkspace ------------------------- */
const DESKTOP_MENU_ITEMS = [
  { value: 'dashboard', label: 'Dashboard', icon: 'dashboard' },
  { value: 'universidade', label: 'Universidade', icon: 'universidade' },
  { value: 'projetos', label: 'Projetos', icon: 'projetos' },
  { value: 'crm', label: 'CRM', icon: 'crm' },
  { value: 'financeiro', label: 'Financeiro', icon: 'financeiro' },
  { value: 'marketing', label: 'Marketing', icon: 'marketing' },
  { value: 'documentos', label: 'Documentos', icon: 'documentos' },
  { value: 'agenda', label: 'Agenda', icon: 'agenda' },
  { value: 'ia', label: 'IA', icon: 'ia' },
  { value: 'comunidade', label: 'Comunidade', icon: 'comunidade' },
  { value: 'configuracoes', label: 'Configurações', icon: 'configuracoes' },
];

function WebWorkspace({ activeTab, onTabChange }) {
  return (
    <div className="flex w-full min-h-[680px] bg-background border border-border rounded-modal overflow-hidden shadow-md">
      {/* Sidebar */}
      <aside className="w-60 bg-white border-r border-border flex flex-col py-6">
        <div className="px-6 mb-8 flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center text-white font-display font-semibold text-lg">S</div>
          <span className="font-display text-xl font-bold tracking-tight text-primary">SON</span>
        </div>
        <nav className="flex-1 px-3 space-y-0.5 overflow-y-auto">
          {DESKTOP_MENU_ITEMS.map((item) => {
            const isActive = activeTab === item.value;
            return (
              <button
                key={item.value}
                onClick={() => onTabChange(item.value)}
                className={`w-full flex items-center gap-3 px-3.5 py-2.5 rounded-button text-small font-medium transition-custom
                  ${isActive ? 'bg-primary text-white font-semibold shadow-sm' : 'text-text-secondary hover:text-text-primary hover:bg-background'}`}
              >
                <span className={isActive ? 'text-accent' : 'text-text-secondary/70'}>
                  <SVGIcon name={item.icon} className="w-4.5 h-4.5" />
                </span>
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      {/* Core Content area */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 bg-white border-b border-border px-6 flex items-center justify-between">
          <div className="w-64 relative flex items-center">
            <span className="absolute left-3 text-text-secondary/60">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </span>
            <input
              type="search"
              placeholder="Pesquisar..."
              className="w-full bg-background border border-border pl-9 pr-3 py-1.5 text-small rounded-input focus:outline-none focus:ring-2 focus:ring-primary/10 focus:border-primary placeholder:text-text-secondary/40 font-body transition-colors"
            />
          </div>
          <div className="flex items-center gap-4">
            <button className="text-text-secondary hover:text-text-primary p-1.5 hover:bg-background rounded-button">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </button>
            <button className="text-text-secondary hover:text-text-primary p-1.5 hover:bg-background rounded-button relative">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <span className="absolute top-1 right-1 w-1.5 h-1.5 bg-danger rounded-full" />
            </button>
            <div className="w-px h-5 bg-border" />
            <div className="flex items-center gap-2.5">
              <div className="text-right hidden sm:block">
                <p className="text-caption font-bold text-text-primary leading-tight">Silvana</p>
                <p className="text-[10px] text-text-secondary">Empreendedora</p>
              </div>
              <div className="w-8 h-8 rounded-full bg-accent text-primary flex items-center justify-center text-caption font-bold border border-border">Sil</div>
            </div>
          </div>
        </header>

        <main className="flex-1 p-6 overflow-y-auto space-y-6">
          {activeTab === 'dashboard' ? (
            <div className="space-y-6">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white border border-border p-5 rounded-card shadow-sm">
                <div>
                  <h1 className="font-display text-h3 font-bold text-text-primary mb-0.5">Bom dia, Silvana</h1>
                  <p className="text-text-secondary text-small">Clareza e organização ajudam você a decidir mais rápido.</p>
                </div>
                <div className="flex items-center gap-4 divide-x divide-border bg-background px-4 py-2.5 rounded-button text-caption">
                  <div>
                    <p className="text-text-secondary font-medium uppercase tracking-wider text-[9px]">Hoje</p>
                    <p className="font-bold text-primary">8 tarefas</p>
                  </div>
                  <div className="pl-4">
                    <p className="text-text-secondary font-medium uppercase tracking-wider text-[9px]">Reuniões</p>
                    <p className="font-bold text-primary">2 reuniões</p>
                  </div>
                  <div className="pl-4">
                    <p className="text-text-secondary font-medium uppercase tracking-wider text-[9px]">Leads</p>
                    <p className="font-bold text-primary">4 novos</p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {['Faturamento Mensal', 'Conversão de Leads', 'Novos Contratos', 'CAC Médio'].map((label, i) => (
                  <div key={label} className="bg-white border border-border p-5 rounded-card shadow-sm">
                    <p className="text-[10px] text-text-secondary font-semibold uppercase tracking-wider mb-1">{label}</p>
                    <p className="text-h4 font-display font-bold text-text-primary">
                      {i === 0 ? 'R$ 45.230' : i === 1 ? '18.6%' : i === 2 ? '14 ativos' : 'R$ 142'}
                    </p>
                    <span className="text-[10px] font-semibold text-success flex items-center gap-0.5 mt-1">{i !== 2 ? '↑ +12%' : 'Estável'}</span>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 space-y-6">
                  <Chart title="Desempenho Semanal" type="line" data={[40, 55, 48, 70, 62, 88, 95]} />

                  <div className="space-y-3">
                    <h4 className="font-display text-body font-bold text-text-primary">Projetos Ativos</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="bg-white border border-border p-5 rounded-card shadow-sm space-y-3">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-accent/30 text-primary">CRM</span>
                        <h5 className="text-small font-bold text-text-primary">Migração de Contatos</h5>
                        <div className="w-full bg-background h-1.5 rounded-full overflow-hidden">
                          <div className="bg-primary h-full" style={{ width: '75%' }} />
                        </div>
                      </div>
                      <div className="bg-white border border-border p-5 rounded-card shadow-sm space-y-3">
                        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-border text-text-secondary">MARKETING</span>
                        <h5 className="text-small font-bold text-text-primary">Campanha de Inverno</h5>
                        <div className="w-full bg-background h-1.5 rounded-full overflow-hidden">
                          <div className="bg-secondary h-full" style={{ width: '40%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="bg-white border border-border p-5 rounded-card shadow-sm space-y-4">
                    <h4 className="text-caption font-bold text-text-primary uppercase tracking-wide border-b border-border pb-3">Agenda</h4>
                    <div className="space-y-3 text-caption">
                      <div className="flex gap-3">
                        <div className="bg-background px-2.5 py-1.5 rounded-button text-center font-bold">09:00</div>
                        <div>
                          <p className="font-bold text-text-primary">Daily Standup</p>
                          <p className="text-text-secondary text-[11px]">Sincronização diária.</p>
                        </div>
                      </div>
                      <div className="flex gap-3">
                        <div className="bg-accent/20 px-2.5 py-1.5 rounded-button text-center font-bold text-primary">14:30</div>
                        <div>
                          <p className="font-bold text-text-primary">Apresentação CRM</p>
                          <p className="text-text-secondary text-[11px]">Homologação final.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white border border-border p-5 rounded-card shadow-sm space-y-4">
                    <h4 className="text-caption font-bold text-text-primary uppercase tracking-wide border-b border-border pb-3">Atividades Recentes</h4>
                    <div className="space-y-3 relative pl-3 before:absolute before:left-0.5 before:top-1 before:bottom-1 before:w-px before:bg-border text-caption">
                      <div className="relative">
                        <span className="absolute -left-[14.5px] top-1 w-1.5 h-1.5 rounded-full bg-success ring-4 ring-white" />
                        <p className="font-bold text-text-primary">Novo lead importado</p>
                        <p className="text-[11px] text-text-secondary">Há 5 min</p>
                      </div>
                      <div className="relative">
                        <span className="absolute -left-[14.5px] top-1 w-1.5 h-1.5 rounded-full bg-info ring-4 ring-white" />
                        <p className="font-bold text-text-primary">Fatura emitida</p>
                        <p className="text-[11px] text-text-secondary">Há 1 hora</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="h-64 flex flex-col items-center justify-center border border-dashed border-border bg-white rounded-card p-8 text-center">
              <div className="text-4xl mb-3">🛠️</div>
              <h3 className="text-body font-bold text-text-primary uppercase tracking-wider">Módulo: {activeTab.toUpperCase()}</h3>
              <p className="text-small text-text-secondary max-w-sm mt-1">Este módulo segue os princípios do SON Design System. Menos ruído, mais clareza para a ação do empreendedor.</p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

/* ------------------------- MobileSimulator ------------------------- */
const MOBILE_MENU_ITEMS = [
  { value: 'dashboard', label: 'Dashboard', icon: 'dashboard' },
  { value: 'agenda', label: 'Agenda', icon: 'agenda' },
  { value: 'crm', label: 'CRM', icon: 'crm' },
  { value: 'ia', label: 'IA', icon: 'ia' },
  { value: 'perfil', label: 'Perfil', icon: 'perfil' },
];

function MobileSimulator() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="flex flex-col items-center py-6">
      <div className="relative mx-auto w-[360px] h-[720px] bg-white border-[14px] border-primary-dark rounded-[40px] shadow-2xl overflow-hidden flex flex-col">
        <div className="absolute top-0 inset-x-0 h-6 bg-primary-dark flex justify-center items-center z-50">
          <div className="w-20 h-3.5 bg-black rounded-b-xl flex items-center justify-center">
            <div className="w-8 h-1 bg-neutral-800 rounded-full"></div>
          </div>
        </div>

        <header className="pt-8 pb-3 px-4 bg-white border-b border-border flex items-center justify-between shrink-0">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-primary flex items-center justify-center text-white font-display font-semibold text-xs">S</div>
            <span className="font-display font-bold text-text-primary text-small">SON Mobile</span>
          </div>
          <div className="w-7 h-7 rounded-full bg-accent text-primary flex items-center justify-center text-[10px] font-bold">Sil</div>
        </header>

        <main className="flex-1 overflow-y-auto p-4 space-y-4 bg-background">
          {activeTab === 'dashboard' ? (
            <div className="space-y-4 text-left">
              <div className="bg-white p-4 border border-border rounded-card shadow-sm">
                <h1 className="font-display text-body font-bold text-text-primary leading-tight">Bom dia, Silvana</h1>
                <p className="text-[11px] text-text-secondary mt-1">Status de Hoje:</p>
                <div className="grid grid-cols-3 gap-2 mt-3 text-center text-caption bg-background p-2.5 rounded-button">
                  <div>
                    <p className="text-[9px] text-text-secondary uppercase">Tarefas</p>
                    <p className="font-bold text-primary">8</p>
                  </div>
                  <div className="border-x border-border">
                    <p className="text-[9px] text-text-secondary uppercase">Reuniões</p>
                    <p className="font-bold text-primary">2</p>
                  </div>
                  <div>
                    <p className="text-[9px] text-text-secondary uppercase">Leads</p>
                    <p className="font-bold text-primary">4</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-4 border border-border rounded-card shadow-sm space-y-3">
                <h3 className="text-caption font-bold text-text-primary uppercase tracking-wider">Metas Financeiras</h3>
                <div className="flex justify-between items-center">
                  <span className="text-caption text-text-secondary">Faturamento</span>
                  <span className="font-bold text-text-primary text-small">R$ 45.230</span>
                </div>
                <div className="w-full bg-background h-1.5 rounded-full overflow-hidden">
                  <div className="bg-primary h-full" style={{ width: '68%' }} />
                </div>
              </div>

              <div className="bg-white p-4 border border-border rounded-card shadow-sm space-y-3">
                <h3 className="text-caption font-bold text-text-primary uppercase tracking-wider">Próximo Compromisso</h3>
                <div className="flex gap-3 text-caption">
                  <div className="bg-background px-2.5 py-1.5 rounded-button text-center font-bold h-fit">09:00</div>
                  <div>
                    <p className="font-bold text-text-primary">Daily Standup</p>
                    <p className="text-[11px] text-text-secondary">Alinhamento matinal.</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="h-64 flex flex-col items-center justify-center bg-white border border-border rounded-card p-6 text-center">
              <p className="text-3xl mb-2">📱</p>
              <h4 className="text-caption font-bold text-text-primary uppercase tracking-wider">Módulo Mobile: {activeTab.toUpperCase()}</h4>
              <p className="text-[11px] text-text-secondary mt-1">Interface compacta dedicada ao empreendedor.</p>
            </div>
          )}
        </main>

        <nav className="bg-white border-t border-border py-2.5 px-2 flex items-center justify-around shrink-0 z-10 shadow-lg">
          {MOBILE_MENU_ITEMS.map((item) => {
            const isActive = activeTab === item.value;
            return (
              <button key={item.value} onClick={() => setActiveTab(item.value)} className="flex flex-col items-center gap-1.5 focus:outline-none">
                <span className={`transition-colors ${isActive ? 'text-primary' : 'text-text-secondary/70'}`}>
                  <SVGIcon name={item.icon} className="w-5 h-5" />
                </span>
                <span className={`text-[10px] transition-colors font-medium ${isActive ? 'text-primary font-semibold' : 'text-text-secondary/70'}`}>{item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}

/* ------------------------- SecurityFlow ------------------------- */
function SecurityFlow() {
  const [step, setStep] = useState('login'); // login | mfa | sessions
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [mfaCode, setMfaCode] = useState('');
  const [sessions, setSessions] = useState([
    { id: 1, os: 'Windows', browser: 'Chrome', location: 'São Paulo', activeTime: 'Ontem', current: false },
    { id: 2, os: 'macOS', browser: 'Safari', location: 'Rio de Janeiro', activeTime: 'Agora mesmo', current: true },
  ]);

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setStep('mfa');
  };

  const handleMfaSubmit = (e) => {
    e.preventDefault();
    if (mfaCode === '123456') {
      setStep('sessions');
    } else {
      alert('Código inválido! Digite o código oficial 123456');
    }
  };

  const handleEndSession = (id) => {
    setSessions(sessions.filter((s) => s.id !== id));
  };

  return (
    <div className="flex flex-col items-center justify-center py-6 min-h-[480px]">
      {step === 'login' && (
        <div className="w-full max-w-[400px] bg-white border border-border p-8 rounded-card shadow-md font-body space-y-6 text-left">
          <div className="text-center">
            <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center text-white font-display font-semibold text-2xl mx-auto mb-3">S</div>
            <h2 className="font-display text-h3 font-bold text-text-primary">SON</h2>
            <p className="text-caption text-text-secondary mt-1">Conecte-se para gerenciar seus negócios.</p>
          </div>

          <form onSubmit={handleLoginSubmit} className="space-y-4">
            <div>
              <Label required>Email</Label>
              <Input type="email" placeholder="Silvana@empresa.com" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <div className="flex justify-between items-center mb-1.5">
                <Label required>Senha</Label>
                <button type="button" className="text-caption font-semibold text-primary hover:underline">Esqueci minha senha</button>
              </div>
              <Input type="password" placeholder="••••••••" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <Checkbox id="rememberCheck" label="Permanecer conectado" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            <Button type="submit" className="w-full mt-2">Entrar</Button>
          </form>

          <div className="flex items-center my-4">
            <div className="flex-grow border-t border-border" />
            <span className="px-3 text-caption text-text-secondary uppercase font-semibold tracking-wider">ou</span>
            <div className="flex-grow border-t border-border" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Button variant="secondary" size="sm" type="button" className="w-full flex items-center justify-center gap-2">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.24 10.285V13.4h6.887c-.275 1.565-1.88 4.604-6.887 4.604-4.33 0-7.859-3.578-7.859-8s3.53-8 7.859-8c2.46 0 4.105 1.025 5.047 1.926l2.427-2.334C17.955 2.192 15.34 1 12.24 1 5.92 1 1 5.92 1 12s4.92 11 11.24 11c6.59 0 11-4.64 11-11.2 0-.753-.08-1.32-.178-1.815H12.24z" />
              </svg>
              Google
            </Button>
            <Button variant="secondary" size="sm" type="button" className="w-full flex items-center justify-center gap-2">
              <svg className="w-4 h-4" viewBox="0 0 23 23" fill="currentColor">
                <path d="M0 0h11v11H0z" fill="#f25022" /><path d="M12 0h11v11H12z" fill="#7fba00" /><path d="M0 12h11v11H0z" fill="#00a4ef" /><path d="M12 12h11v11H12z" fill="#ffb900" />
              </svg>
              Microsoft
            </Button>
          </div>
        </div>
      )}

      {step === 'mfa' && (
        <div className="w-full max-w-[400px] bg-white border border-border p-8 rounded-card shadow-md font-body space-y-6 text-left">
          <div className="text-center">
            <div className="w-12 h-12 rounded-xl bg-accent/25 flex items-center justify-center text-primary font-bold text-2xl mx-auto mb-3">🛡️</div>
            <h2 className="font-display text-h3 font-bold text-text-primary">MFA Ativado</h2>
            <p className="text-caption text-text-secondary mt-1">Digite o código de verificação enviado para seu dispositivo.</p>
          </div>

          <form onSubmit={handleMfaSubmit} className="space-y-4">
            <div>
              <Label>Código de Verificação</Label>
              <Input
                type="text"
                placeholder="123456"
                maxLength={6}
                required
                value={mfaCode}
                onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, ''))}
                className="text-center tracking-[0.5em] text-h4 font-bold font-mono"
              />
              <div className="flex justify-between items-center mt-2.5">
                <span className="text-caption text-text-secondary">Digite o código: <strong className="text-primary">123456</strong></span>
                <button type="button" onClick={() => setMfaCode('123456')} className="text-caption font-bold text-primary hover:underline">Autopreencher</button>
              </div>
            </div>
            <Button type="submit" disabled={mfaCode.length !== 6} className="w-full mt-2">Verificar</Button>
            <Button variant="tertiary" type="button" onClick={() => setStep('login')} className="w-full">Voltar</Button>
          </form>
        </div>
      )}

      {step === 'sessions' && (
        <div className="w-full max-w-[500px] bg-white border border-border p-6 rounded-card shadow-sm font-body space-y-6 text-left">
          <div>
            <div className="flex justify-between items-center">
              <h3 className="text-body font-bold text-text-primary uppercase tracking-wide">Sessões Ativas</h3>
              <button onClick={() => setStep('login')} className="text-caption font-bold text-danger hover:underline">Fazer Logout</button>
            </div>
            <p className="text-caption text-text-secondary mt-1">Gerencie os dispositivos conectados à sua conta SON.</p>
          </div>

          <div className="divide-y divide-border">
            {sessions.map((session) => (
              <div key={session.id} className="py-4 flex justify-between items-center first:pt-0 last:pb-0">
                <div className="flex gap-3 items-center">
                  <div className="w-10 h-10 rounded-button bg-background flex items-center justify-center text-lg text-text-secondary">
                    {session.os === 'Windows' ? '💻' : '📱'}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-small font-bold text-text-primary">{session.os} · {session.browser}</p>
                      {session.current && <span className="text-[10px] px-2 py-0.5 bg-success/15 text-success rounded-full font-semibold">Esta sessão</span>}
                    </div>
                    <p className="text-caption text-text-secondary">{session.location} · {session.activeTime}</p>
                  </div>
                </div>

                {!session.current && (
                  <Button variant="tertiary" size="sm" onClick={() => handleEndSession(session.id)} className="text-danger hover:bg-danger/5 hover:text-danger font-semibold">
                    Encerrar
                  </Button>
                )}
              </div>
            ))}
            {sessions.length === 0 && <div className="py-6 text-center text-caption text-text-secondary">Nenhuma outra sessão ativa encontrada.</div>}
          </div>
        </div>
      )}
    </div>
  );
}

/* ------------------------- ComponentCatalog ------------------------- */
function ComponentCatalog() {
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [switchVal, setSwitchVal] = useState(false);
  const [checkVal, setCheckVal] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState('success');
  const [toastMsg, setToastMsg] = useState('Ação executada com sucesso!');

  const triggerToast = (type, msg) => {
    setToastType(type);
    setToastMsg(msg);
    setToastOpen(true);
    setTimeout(() => setToastOpen(false), 3000);
  };

  const handleButtonClick = () => {
    setLoadingBtn(true);
    setTimeout(() => {
      setLoadingBtn(false);
      triggerToast('success', 'Carregamento finalizado com sucesso!');
    }, 1500);
  };

  return (
    <div className="space-y-12 text-left bg-white border border-border p-8 rounded-modal shadow-sm">
      <section className="space-y-4">
        <h3 className="font-display text-h4 font-bold text-text-primary border-b border-border pb-2">Botões</h3>
        <p className="text-caption text-text-secondary">Biblioteca única de botões com estilo SON (raio de borda 12px).</p>
        <div className="flex flex-wrap gap-4 items-center">
          <Button variant="primary" onClick={handleButtonClick} loading={loadingBtn}>Primário ( chocolate )</Button>
          <Button variant="secondary" onClick={() => triggerToast('info', 'Botão Secundário acionado!')}>Secundário ( outline )</Button>
          <Button variant="tertiary" onClick={() => triggerToast('warning', 'Botão Terciário acionado!')}>Terciário ( texto )</Button>
          <Button variant="danger" onClick={() => triggerToast('error', 'Ação destrutiva acionada!')}>Destrutivo</Button>
        </div>
        <div className="flex flex-wrap gap-4 items-center pt-2">
          <Button variant="primary" size="sm">Pequeno (sm)</Button>
          <Button variant="primary" size="md">Médio (md)</Button>
          <Button variant="primary" size="lg">Grande (lg)</Button>
          <Button variant="primary" disabled>Desabilitado</Button>
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="font-display text-h4 font-bold text-text-primary border-b border-border pb-2">Campos de Entrada</h3>
        <p className="text-caption text-text-secondary">Inputs com cantos arredondados de 12px e estados de feedback.</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <Label htmlFor="inputNormal">Normal / Placeholder</Label>
            <Input id="inputNormal" placeholder="Digite seu nome..." value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
          </div>

          <div>
            <Label htmlFor="inputError" required>Estado de Erro</Label>
            <Input id="inputError" error placeholder="Insira o valor..." defaultValue="Valor incorreto" />
            <span className="text-[11px] text-danger mt-1 block">Este campo é obrigatório.</span>
          </div>

          <div>
            <Label htmlFor="inputSuccess">Estado de Sucesso</Label>
            <Input id="inputSuccess" success placeholder="Digitando..." defaultValue="Informação válida!" />
            <span className="text-[11px] text-success mt-1 block">Verificação concluída.</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-8 items-center pt-4">
          <Checkbox id="catCheck" label="Checkbox selecionado" checked={checkVal} onChange={(e) => setCheckVal(e.target.checked)} />
          <Switch id="catSwitch" label="Notificações em tempo real" checked={switchVal} onChange={setSwitchVal} />
        </div>
      </section>

      <section className="space-y-4">
        <h3 className="font-display text-h4 font-bold text-text-primary border-b border-border pb-2">Alertas, Modais & Notificações</h3>
        <p className="text-caption text-text-secondary">Elementos de feedback discretos, respeitando a calma visual da interface.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Alert variant="success" title="✔ Operação Realizada">Os dados de faturamento foram atualizados com sucesso.</Alert>
          <Alert variant="warning" title="⚠ Revisão Necessária">Existem 2 tarefas atrasadas na agenda de hoje.</Alert>
          <Alert variant="error" title="❌ Erro na Conexão">Falha ao tentar se comunicar com o banco de dados.</Alert>
          <Alert variant="info" title="ℹ Informações de Sessão">Nova sessão ativada a partir de São Paulo.</Alert>
        </div>

        <div className="flex gap-4 pt-4">
          <Button variant="secondary" onClick={() => setModalOpen(true)}>Abrir Modal (640px)</Button>
          <Button variant="secondary" onClick={() => triggerToast('success', 'Isso é uma notificação Toast!')}>Disparar Toast</Button>
        </div>
      </section>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Atenção Empreendedor"
        description="Esta decisão impactará seus relatórios financeiros do mês de julho."
        onConfirm={() => {
          setModalOpen(false);
          triggerToast('success', 'Configuração financeira alterada!');
        }}
        confirmText="Salvar Alterações"
        cancelText="Descartar"
      >
        <p className="text-small text-text-secondary mb-4">Você está prestes a recalcular as projeções de CAC. Deseja prosseguir com essa alteração no painel de KPIs?</p>
        <div className="bg-background p-4 rounded-button border border-border">
          <p className="text-caption font-semibold text-text-primary">Fórmula aplicada:</p>
          <p className="text-caption text-text-secondary font-mono mt-1">CAC = (Investimento Marketing + Vendas) / Novos Clientes</p>
        </div>
      </Modal>

      <Toast open={toastOpen} onClose={() => setToastOpen(false)} message={toastMsg} type={toastType} />
    </div>
  );
}

/* ============================================================
   ShowcaseApp — componente principal (default export)
   ============================================================ */
export default function ShowcaseApp() {
  const [showcaseTab, setShowcaseTab] = useState('foundations');
  const [activeWorkspaceTab, setActiveWorkspaceTab] = useState('dashboard');

  return (
    <div className="min-h-screen flex flex-col font-body bg-background text-text-primary">
      <header className="bg-primary text-white py-6 px-8 shadow-md shrink-0">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-accent text-primary flex items-center justify-center font-display font-bold text-xl shadow">S</div>
            <div>
              <h1 className="font-display text-h3 font-bold leading-tight">SON Design System</h1>
              <p className="text-accent/80 text-caption font-medium tracking-wide">&quot;Menos ruído. Mais clareza para decidir.&quot;</p>
            </div>
          </div>

          <nav className="flex flex-wrap gap-2.5 bg-primary-light/50 p-1.5 rounded-button border border-primary-light">
            {[
              
              { value: 'workspace', label: '03. Dashboard (Web)' },
              { value: 'mobile', label: '04. Simulador (Mobile)' },
           
            ].map((tab) => (
              <button
                key={tab.value}
                onClick={() => setShowcaseTab(tab.value)}
                className={`px-4 py-2 rounded-button text-caption font-semibold transition-all duration-150
                  ${showcaseTab === tab.value ? 'bg-accent text-primary shadow' : 'text-white/80 hover:text-white hover:bg-white/10'}`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </header>

      <main className="flex-grow max-w-7xl w-full mx-auto p-6 md:p-8">
        {showcaseTab === 'foundations' && (
          <div className="space-y-8 animate-in fade-in duration-200">
            <div className="bg-white border border-border p-8 rounded-modal shadow-sm space-y-6 text-left">
              <span className="text-[10px] font-bold tracking-wider text-secondary uppercase bg-background px-3 py-1 rounded-full">Filosofia do Sistema</span>
              <h2 className="font-display text-h2 font-bold text-text-primary leading-tight">Menos ruído. Mais clareza para decidir.</h2>
              <p className="text-text-secondary text-body max-w-3xl leading-relaxed">
                O <strong>SON Design System</strong> é exclusivo, focado no empreendedor. Ele elimina a sobrecarga de informações, simplifica a hierarquia visual e incentiva a ação rápida. Toda tela deve responder em menos de 5 segundos às seguintes perguntas do usuário:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-background p-6 rounded-card border border-border">
                <div className="p-4 bg-white rounded-button shadow-sm border border-border/60">
                  <p className="text-caption text-text-secondary uppercase font-semibold">01. Onde estou?</p>
                  <p className="text-small text-text-primary font-medium mt-1">Localização e módulo claros de imediato.</p>
                </div>
                <div className="p-4 bg-white rounded-button shadow-sm border border-border/60">
                  <p className="text-caption text-text-secondary uppercase font-semibold">02. O que posso fazer aqui?</p>
                  <p className="text-small text-text-primary font-medium mt-1">Opções e fluxos de trabalho visíveis sem ruídos.</p>
                </div>
                <div className="p-4 bg-white rounded-button shadow-sm border border-border/60">
                  <p className="text-caption text-text-secondary uppercase font-semibold">03. Qual é a próxima ação?</p>
                  <p className="text-small text-text-primary font-medium mt-1">Botões primários e guias claros indicando o fluxo.</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
              <div className="bg-white border border-border p-6 rounded-modal shadow-sm space-y-4">
                <h3 className="font-display text-h3 font-bold text-text-primary">Os Quatro Pilares do SON</h3>
                <div className="space-y-4 pt-2">
                  {[
                    { title: 'Clareza', desc: 'A informação deve ser compreendida em poucos segundos.' },
                    { title: 'Organização', desc: 'Cada elemento tem um propósito lógico. Sem decorações excessivas.' },
                    { title: 'Segurança', desc: 'A interface transmite confiança nos dados e transações.' },
                    { title: 'Eficiência', desc: 'Menos cliques. Mais ação direta para o empreendedor.' },
                  ].map((pillar, i) => (
                    <div key={pillar.title} className="flex gap-4">
                      <span className="w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center font-bold text-caption shrink-0">{i + 1}</span>
                      <div>
                        <h4 className="font-bold text-small text-text-primary">{pillar.title}</h4>
                        <p className="text-caption text-text-secondary mt-0.5">{pillar.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white border border-border p-6 rounded-modal shadow-sm space-y-6">
                <h3 className="font-display text-h3 font-bold text-text-primary">Paleta Oficial</h3>

                <div className="space-y-3">
                  <h4 className="text-caption font-bold text-text-secondary uppercase tracking-wider">Cores Principais</h4>
                  <div className="grid grid-cols-4 gap-2 text-center text-[10px]">
                    <div>
                      <div className="h-12 bg-[#351514] rounded-button border border-border" />
                      <p className="font-semibold text-text-primary mt-1">Primary</p>
                      <p className="text-text-secondary font-mono">#351514</p>
                    </div>
                    <div>
                      <div className="h-12 bg-[#7F6A60] rounded-button border border-border" />
                      <p className="font-semibold text-text-primary mt-1">Secondary</p>
                      <p className="text-text-secondary font-mono">#7F6A60</p>
                    </div>
                    <div>
                      <div className="h-12 bg-[#F2DB94] rounded-button border border-border" />
                      <p className="font-semibold text-text-primary mt-1">Accent</p>
                      <p className="text-text-secondary font-mono">#F2DB94</p>
                    </div>
                    <div>
                      <div className="h-12 bg-[#F7F5F2] rounded-button border border-border" />
                      <p className="font-semibold text-text-primary mt-1">Background</p>
                      <p className="text-text-secondary font-mono">#F7F5F2</p>
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <h4 className="text-caption font-bold text-text-secondary uppercase tracking-wider">Feedbacks / Status</h4>
                  <div className="grid grid-cols-4 gap-2 text-center text-[10px]">
                    <div>
                      <div className="h-10 bg-[#4CAF50] rounded-button" />
                      <p className="font-semibold text-text-primary mt-1">Success</p>
                      <p className="text-text-secondary font-mono">#4CAF50</p>
                    </div>
                    <div>
                      <div className="h-10 bg-[#F4B400] rounded-button" />
                      <p className="font-semibold text-text-primary mt-1">Warning</p>
                      <p className="text-text-secondary font-mono">#F4B400</p>
                    </div>
                    <div>
                      <div className="h-10 bg-[#D93025] rounded-button" />
                      <p className="font-semibold text-text-primary mt-1">Danger</p>
                      <p className="text-text-secondary font-mono">#D93025</p>
                    </div>
                    <div>
                      <div className="h-10 bg-[#4285F4] rounded-button" />
                      <p className="font-semibold text-text-primary mt-1">Info</p>
                      <p className="text-text-secondary font-mono">#4285F4</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {showcaseTab === 'catalog' && (
          <div className="animate-in fade-in duration-200">
            <ComponentCatalog />
          </div>
        )}

        {showcaseTab === 'workspace' && (
          <div className="space-y-4 animate-in fade-in duration-200">
            <div className="text-left bg-white border border-border p-5 rounded-card shadow-sm">
              <h3 className="font-display text-h3 font-bold text-text-primary">Painel do Sistema (Web)</h3>
              <p className="text-caption text-text-secondary mt-1">Uma simulação da área administrativa do SON, focada em organização e painéis limpos.</p>
            </div>
            <WebWorkspace activeTab={activeWorkspaceTab} onTabChange={setActiveWorkspaceTab} />
          </div>
        )}

        {showcaseTab === 'mobile' && (
          <div className="space-y-4 animate-in fade-in duration-200">
            <div className="text-left bg-white border border-border p-5 rounded-card shadow-sm">
              <h3 className="font-display text-h3 font-bold text-text-primary">Simulação Mobile (App)</h3>
              <p className="text-caption text-text-secondary mt-1">Quando aberto em smartphones, o menu lateral do SON vira uma Bottom Navigation simplificada com até 5 itens principais.</p>
            </div>
            <MobileSimulator />
          </div>
        )}

        {showcaseTab === 'security' && (
          <div className="space-y-4 animate-in fade-in duration-200">
            <div className="text-left bg-white border border-border p-5 rounded-card shadow-sm">
              <h3 className="font-display text-h3 font-bold text-text-primary">Fluxos de Acesso & Segurança</h3>
              <p className="text-caption text-text-secondary mt-1">Simulação interativa da tela de login, o fluxo de segundo fator (MFA) e gerenciador de conexões ativas.</p>
            </div>
            <SecurityFlow />
          </div>
        )}
      </main>

      <footer className="py-6 border-t border-border mt-12 text-center text-caption text-text-secondary shrink-0">
        <p>© 2026 SON. Todos os direitos reservados. · Design System v1.0.0</p>
      </footer>
    </div>
  );
}